// src/onboarding/OnboardingGardenSpaces.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).
//
// Scope: Step 1 garden spaces multi-select (front, back, balcony, greenhouse,
// allotment). Persists to tend:gardenSpaces on continue.

import { Check } from 'lucide-react';
import OnbFrame from './OnbFrame.jsx';
import OnbTileArt from './OnbTileArt.jsx';
import { ONBOARD_GARDEN_SPACES } from './constants.js';
import { persistOnboardArray } from '../lib/storage.js';

export default function OnboardingGardenSpaces({data, setData, onContinue, step = 1, total = 5}) {
  const selected = Array.isArray(data.gardenSpaces) ? data.gardenSpaces : [];
  const toggle = (value) => {
    setData(prev => {
      const cur = Array.isArray(prev.gardenSpaces) ? prev.gardenSpaces : [];
      const next = cur.includes(value) ? cur.filter(v => v !== value) : [...cur, value];
      return {...prev, gardenSpaces: next};
    });
  };
  const canContinue = selected.length > 0;
  // Sub-copy per space — keeps tile info dense without extra AI calls.
  const SPACE_SUBLABEL = {
    "front-garden": "Kerbside beds, hedges, a welcoming path",
    "back-garden":  "Lawn, borders, the main growing space",
    "balcony":      "Rail planters, pots, tight sun pockets",
    "greenhouse":   "Under glass — seedlings, tender crops",
    "allotment":    "Off-site plot, rows of food, a shed",
  };
  const handleContinue = () => {
    persistOnboardArray('tend:gardenSpaces', selected);
    onContinue();
  };
  return (
    <OnbFrame step={step} total={total} ground="dawn">
      <div className="onb-content">
        <div style={{ height: 16 }}/>
        <p className="onb-eyebrow">Your garden, wherever it lives</p>
        <h1 className="onb-heading">Where do you <em>grow</em>?</h1>
        <p className="onb-sub">Tick everywhere you have plants — a garden, a balcony, a few pots by the door. We'll keep the advice focused on the spaces you actually have.</p>

        <div className="onb-tiles" style={{ marginTop: 18 }}>
          {ONBOARD_GARDEN_SPACES.map(opt => (
            <button
              key={opt.value}
              type="button"
              aria-pressed={selected.includes(opt.value)}
              data-label={opt.label}
              className={`onb-tile ${selected.includes(opt.value) ? "is-selected" : ""}`}
              onClick={() => toggle(opt.value)}
            >
              <OnbTileArt variant={opt.value}/>
              <div className="onb-tile-label">{opt.label}</div>
              {/* aria-hidden so the tile's accessible name is ONLY the primary */}
              {/* label (e.g. "Back garden"). Test at src/App.test.jsx:1589 uses */}
              {/* an exact-anchored regex /^Back garden$/i against the button's */}
              {/* accessible name — the sub-label must NOT leak into it. */}
              <div className="onb-tile-sub" aria-hidden="true">{SPACE_SUBLABEL[opt.value] || ""}</div>
              <div className="onb-tile-check" aria-hidden="true">
                <Check size={13}/>
              </div>
            </button>
          ))}
        </div>

        <div className="push-bottom">
          <button
            type="button"
            className="onb-cta"
            onClick={handleContinue}
            disabled={!canContinue}
          >
            {canContinue
              ? `Confirm ${selected.length} space${selected.length === 1 ? "" : "s"} →`
              : "Pick at least one →"}
          </button>
        </div>
      </div>
    </OnbFrame>
  );
}
